import { createContext, useReducer, useMemo, useContext } from 'react';

type DelegateProps = {
  poolStatus?: string;
  currentStatus?: string;
  timeLeft?: string;
  procent?: string;
  poolLimit?: string;
  estimatedReturn?: string;
  totalProvided?: string;
  myProvided?: string;
};

const initialState = {
  poolStatus: 'OPEN',
  currentStatus: 'Pool Open',
  timeLeft: '12 Days',
  procent: '50',
  poolLimit: '10,000 OPN',
  estimatedReturn: '15%',
  totalProvided: '4,500.00 OPN',
  myProvided: '10'
};

const DelegateContext = createContext<DelegateProps>(initialState);

DelegateContext.displayName = 'DelegateContext';

const reducer = (s: DelegateProps, v: DelegateProps) => ({ ...s, ...v });

export const DelegateProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [state] = useReducer(reducer, initialState);

  const value = useMemo(
    () => ({
      ...state
    }),
    [state]
  );

  return (
    <DelegateContext.Provider value={value}>
      {children}
    </DelegateContext.Provider>
  );
};

export const useDelegate = () => {
  const context = useContext(DelegateContext);
  if (context === undefined) {
    throw new Error('useDelegate must be used within a DelegateProvider');
  }
  return context;
};
